import React from 'react';
import { Link } from 'react-router-dom';

const RateList = props => {
    if (!props.rates) {
        return (
            <div className='broad'>Loading...</div>
        )
    }

    if (props.rates.length === 0) {
        return (
            <div className='empty'>
                No rates...
      </div>
        );
    }

    return (
        <div>
            <table className="dataTable">
                <thead>
                    <tr>
                        {/* <th>Key</th> */}
                        <th>Symbol</th>
                        <th>Rate</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.rates.map(item => {
                            return (
                                <tr key={item.key}>
                                    {/* <td className="keyfield"><Link to={`/rates/${item.symbol.toLowerCase()}/detail`}>{item.key}</Link></td> */}
                                    <td>{item.symbol}</td>
                                    <td>{item.rate}</td>
                                    <td className="keyfield"><Link to={`/rate/${item.symbol.toLowerCase()}/update`}>Edit</Link></td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default RateList;



// WEBPACK FOOTER //
// ./src/components/widgets/RateList.js